export const searchEvents = (events, text) => {
  const newData = events.filter(
    (item) => {
      const itemData = `${item.title.toUpperCase()}`;
      const textData = text.toUpperCase();
      return itemData.indexOf(textData) > -1;
    }
  );
  return newData;
};

export const searchCustomer = (customers, text) => {
  const newData = customers.filter(
    (item) => {
      const itemData = `${item.firstName.toUpperCase()} ${item.lastName.toUpperCase()}`;
      const textData = text.toUpperCase();
      return itemData.indexOf(textData) > -1;
    }
  );
  return newData;
};

export const searchLeads = (leads, text) => {
  const newData = leads.filter(
    (item) => {
      const itemData = `${item.email.toUpperCase()}`;
      const textData = text.toUpperCase();
      return itemData.indexOf(textData) > -1;
    }
  );
  return newData;
};

export default {
  searchEvents,
  searchLeads,
  searchCustomer
};
